import { Box, Card, Flex, Grid, Heading, Text } from "@radix-ui/themes";
import { TimeObj } from "@/hooks/useCountdown";
import { FC, JSX } from "react";
import React from "react";

import PrizeCard from "../PrizeCard/PrizeCard";

// No Samsung prize confirmed for the Assembly event yet — hide the prize card
// for now. Flip to true (and set brand.prize) when a prize is finalised.
const SHOW_PRIZE = false;

const CountdownClock: FC<{
  timeObj: TimeObj;
  title: "NEXT CHALLENGE IN" | "CHALLENGE ENDS IN";
}> = ({ timeObj, title }): JSX.Element => {
  return (
    <Flex
      direction="column"
      gap="4"
      width="100%"
      height="100%"
      justify={SHOW_PRIZE ? "start" : "center"}
    >
      <Flex
        align="center"
        justify="center"
        width="100%"
        direction="column"
        gap="4"
      >
        <Box width="100%">
          <Heading
            style={{ textTransform: "uppercase", color: "white" }}
            weight="medium"
            as="h2"
            size="6"
            m="0"
            trim="both"
          >
            {title}
          </Heading>
        </Box>

        <Grid
          width="100%"
          columns="3"
          align="center"
          justify="center"
          gap="6"
          mb="4"
        >
          {(["hours", "minutes", "seconds"] as (keyof TimeObj)[]).map(
            (unit) => (
              <React.Fragment key={unit}>
                <Box width="100%">
                  <Card className="sr-clock-cell">
                    <Box p="3">
                      <Flex align="center" direction="column">
                        <Text
                          style={{ fontSize: "4rem", lineHeight: "4rem" }}
                          mb="0"
                          weight="bold"
                        >
                          {timeObj[unit]}
                        </Text>
                        <Text weight="bold" size="7">
                          {unit.toUpperCase()}
                        </Text>
                      </Flex>
                    </Box>
                  </Card>
                </Box>
              </React.Fragment>
            )
          )}
        </Grid>
      </Flex>

      {SHOW_PRIZE && <PrizeCard />}
    </Flex>
  );
};

export default CountdownClock;
